<ng-template #offlineModalTpl>
    <div class="modal-body">
        <div class="offline text-center">
            <div><i class="icon-network-offline text-danger"></i></div>
            <h4 class="text">Connection to server has been lost.</h4>
        </div>
    </div>
</ng-template>
<style>
    .icon-network-offline {
        font-size: 3em;
    }

    .text {
        margin-top: 1rem;
    }
</style>
